import * as React from 'react';
import CheckoutBillingAddressForm, { ICheckoutBillingAddressProps } from './checkout_billing_address_form';
import CreditCardHtmlForm from './credit_card_html_form';

// if a user has no cards on file, we render this comp
const CheckoutNewCreditCardAndBillingAddressForm: React.StatelessComponent<ICheckoutBillingAddressProps> = (props) => {
  return (
    <div>
      <div className="module">
        <CreditCardHtmlForm />
      </div>

      <CheckoutBillingAddressForm {...props} />
    </div>
  );
};

export default CheckoutNewCreditCardAndBillingAddressForm;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_new_credit_card_and_billing_address_form.tsx